import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'

import { attributesNames } from '../../../../constants'
import { Logger, LoggerTypes } from '../../../../utils'
import { AttributeToolsHeader } from '../../AttributeToolsHeader'
import { AttributeResourceDialogCreate } from '../dialogs'
import { AttributeResourceCard } from '../AttributeResourceCard'

export const AttributeResourcePanel = ({
  resources,
  parameters,
  currentProject,
  currentScenario,
  terms,
  openDialog,
  setOpenDialog,
  onSearch,
  onAdd,
  onUpdate,
  onImport,
  onDelete,
  onCreate
}) => {
  Logger.trace(LoggerTypes.CONTAINER, 'AttributeResourcePanel.render()', {
    currentProject,
    currentScenario,
    resources,
    parameters,
    terms
  })

  const TAB_PANEL_HEIGHT = `${$(window).height() - 265}px`

  return (
    <div className="AttributeResourcePanel" style={{ overflow: 'hidden auto', height: TAB_PANEL_HEIGHT }}>
      <AttributeToolsHeader
        currentProject={currentProject}
        currentScenario={currentScenario}
        attributeName={attributesNames.RESOURCES}
        terms={terms}
        onSearch={onSearch}
        onAdd={onAdd}
        onImport={onImport}
      />
      <div className="attributes-list">
        {resources &&
          resources.map((resource, index) => (
            <AttributeResourceCard
              key={`resource-${index}`}
              resource={resource}
              parameters={parameters}
              currentProject={currentProject}
              currentScenario={currentScenario}
              actionDispatchDelete={onDelete}
              actionDispatchUpdate={onUpdate}
            />
          ))}
      </div>
      {openDialog && (
        <AttributeResourceDialogCreate
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          actionCreateDispatch={onCreate}
          currentProject={currentProject}
          currentScenario={currentScenario}
          parameters={parameters}
        />
      )}
    </div>
  )
}

AttributeResourcePanel.displayName = 'AttributeResourcePanel'

AttributeResourcePanel.propTypes = {
  resources: PropTypes.arrayOf(PropTypes.object).isRequired,
  parameters: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  terms: PropTypes.string.isRequired,
  onSearch: PropTypes.func,
  onAdd: PropTypes.func,
  onUpdate: PropTypes.func,
  onDelete: PropTypes.func,
  onCreate: PropTypes.func,
  onImport: PropTypes.func
}

AttributeResourcePanel.defaultProps = {
  resources: [],
  parameters: [],
  currentProject: null,
  currentScenario: null,
  terms: '',
  openDialog: false,
  setOpenDialog: () => {},
  onSearch: null,
  onAdd: null,
  onUpdate: null,
  onDelete: null,
  onCreate: null,
  onImport: null
}
